import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ChecklistModel } from '../model/checklist.model';


@Injectable()
export class ChecklistService {

  path = '/checklist';
  id: number;

  constructor(private baseService: BaseService) {}

  getPaginated(init: number, end: number, name: string) {
    return this.baseService.get(this.path, '', { init, end, name });
  }
  getActive() {
    return this.baseService.get(this.path, '', { init:0 })
  }
  findById(id: number) {
    return this.baseService.get(this.path, '/' + id, {
      withHeaderItems: true,
      withQuestions: true,
      withDefaults: true,
      withEmails: true,
    });
  }

  findBaseInfoById(id: number) {
    return this.baseService.get(this.path, '/base-info/' + id);
  }

  post(checklist: ChecklistModel) {
    return this.baseService.post(this.path, '/', checklist);
  }

  put(checklist: ChecklistModel) {
    return this.baseService.put(this.path, '/', checklist);
  }

  save(checklist: ChecklistModel) {
    return this.post(checklist);    
  }

  setId(id) {
    this.id = id;
  }

  getId() {
    return this.id;
  }

  saveInstitutesDepartaments(record) {
    return this.baseService.post(this.path, '/' + record.checklist_id + '/institutes-departaments', record.institutes);
  }
  disableCheckList(id) {
    return this.baseService.post(this.path, `/disable/${id}`, {})
  }
  findAllQuestionGroups(id: number) {
    return this.baseService.get(this.path, '/'+ id + '/question-group');
  }

  findHeaderItems(checklistId: number) {
    return this.baseService.get(this.path, '/' + checklistId + '/header-item');
  }

  getAttachments(checklistId: number) {
    return this.baseService.get(this.path, '/' + checklistId + '/attachments');
  }

  deleteChecklist(id: number) {
    return this.baseService.delete(this.path, '/' + id)
  }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/checklist.service.ts